import { Inject, Injectable, OnInit } from '@angular/core';
import { UserUIProfile } from 'BI-Libraries/BI-Components/projects/bi-modules/src/lib/models/UserUIProfile';
import { CashingUserUIProfileService } from './cashing-user-uiprofile.service';
import { UserInfo } from 'src/app/userInfo';
import { HttpService } from './HttpClientServices/Http.service';
import { BehaviorSubject, catchError, concatMap, map, Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { LoggerService,UiProfileService } from 'BI-Libraries/BI-Components/dist/bi-modules';
import { TranslateService } from '@ngx-translate/core';
import { IColumnConfig } from 'BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/public-api';
import { FavoriteScreensService } from './favorite-screens.service';



@Injectable({
  providedIn: 'root'
})
export class ClientAppUserUIProfileService implements OnInit {

  private destroy$ = new Subject<void>();
  batchRequestData = {requests: []};

  public deleteFavoritePageClickedSubject = new BehaviorSubject<string>('');
  public deleteFavoritePageClicked$ = this.deleteFavoritePageClickedSubject.asObservable();

  

  constructor(
    @Inject('UIUserProfile') private uiProfileService,
    private cashingUserUIProfileService: CashingUserUIProfileService,
    private httpService: HttpService,
    private loggerService: LoggerService,
    private translateService: TranslateService,
    private favoriteScreensService: FavoriteScreensService,
  ) {   
    this.CheckUserUICashOutdated();
  }

  ngOnInit(): void {
      
  }

  public ResetUserUiProfileFilled (){
    this.uiProfileService.IsUserUIProfileFilled = false;
  }
  //#region UserUIProfile Functions
  private CheckUserUICashOutdated(){
    const maxLocalStoredTime = this.cashingUserUIProfileService.GetMaxTimestampFromUserUIProfile()
    if(maxLocalStoredTime == null)
      return;
    
    this.httpService.get(`UserScreenUIData/GetMaxLastModifiedScreenUIConfigs?CashedDate=${maxLocalStoredTime}`)
    .pipe(
      catchError(error => {
        console.error('An error occurred:', error);
        return of(null);
      })
    ).subscribe((lastDBUpdate: string) => {
      if(!lastDBUpdate || new Date(maxLocalStoredTime).getTime() < new Date(lastDBUpdate).getTime()){
        this.cashingUserUIProfileService.RemoveCash();
      }
    });
  }

  public GetScreenUserUIProfile(screenUrl: string){
    this.cashingUserUIProfileService.getUserUIProfile(screenUrl)
    .pipe(takeUntil(this.destroy$))
    .subscribe(userUI =>{
      if(userUI){
        this.uiProfileService.UserUIProfile = userUI;
        this.uiProfileService.UserUIProfile.FavoriteScreens = this.favoriteScreensService.getLocalFavoritePagesFlattenedList();
        let searchCurrentScreenInFav = this.uiProfileService.UserUIProfile.FavoriteScreens.find(s => s.PageUrl == screenUrl);
        if(searchCurrentScreenInFav)
          this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite = true;
        else this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite = false;
        this.uiProfileService.UserUIProfileFilledSubject.next();
        this.uiProfileService.IsUserUIProfileFilled = true;
      }
      else{
        this.RequestScreenUserUIProfileFromBackend(screenUrl)
        .pipe(takeUntil(this.destroy$))
        .subscribe(profile => {
          if(profile){
            this.uiProfileService.UserUIProfile.BS_CustomScreenLayout = profile.BS_CustomScreenLayout;
            this.uiProfileService.UserUIProfile.FavoriteScreens = this.favoriteScreensService.getLocalFavoritePagesFlattenedList(); ///
            this.uiProfileService.UserUIProfile.BS_GridColumnConfigs = profile.BS_GridColumnConfigs;
            let searchCurrentScreenInFav = profile.FavoriteScreens.find(s => s.PageUrl == screenUrl);
            if(searchCurrentScreenInFav)
              this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite = true;
            else this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite = false;
            this.uiProfileService.UserUIProfileFilledSubject.next();
            this.uiProfileService.IsUserUIProfileFilled = true;
            this.cashingUserUIProfileService.Cash(screenUrl,this.uiProfileService.UserUIProfile);
          }
        })
      }
    });
  }

  
  //#endregion

  //#region FAVORITE SCREENS USER INTERACTIONS HANDLERS
  
  subscribeToFavoriteButtonToggle( screenUrl: string){
    let url = this.getUrlSignature(screenUrl);
    let isCurrentFav = false;
    this.uiProfileService.favoriteScreenChanged$
    .pipe(
      takeUntil(this.destroy$),
      switchMap((result:{isFavorite: boolean,pageUrl:string}) => {
        if(result.pageUrl && result.pageUrl.length>0)
          url = result.pageUrl;

        if(result.isFavorite){
          isCurrentFav = true;
          return this.favoriteScreensService.saveDBPageAsFavorite(url)
        }
        else {
          isCurrentFav = false;
         
          const screenDBID = this.uiProfileService.UserUIProfile.FavoriteScreens.find(s => s.PageUrl == url)?.Id;
          return this.favoriteScreensService.deleteDBPageFromFavorite(screenDBID); 
        }
      })
    )
    .subscribe({
      next: response => {
        this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite = isCurrentFav;
        if(isCurrentFav){
          this.favoriteScreensService.saveLocalPageAsFavorite(response.ScreenUrl, response.Id, response.ScreenName);
          this.uiProfileService.UserUIProfile.FavoriteScreens.push({
            Id : response.Id,
            PageName: response.ScreenName,
            PageUrl: response.ScreenUrl,
          })
        }else{
          this.favoriteScreensService.deleteLocalFavoritePage(url);
          this.uiProfileService.UserUIProfile.FavoriteScreens = this.uiProfileService.UserUIProfile.FavoriteScreens
          .filter(f => f.PageUrl != url)
        }

        this.showAlertMessage(this.translateService.instant("SavedSuccessfully"), 2);
        this.cashingUserUIProfileService.Cash(url, this.uiProfileService.UserUIProfile)
      },
      error: error => {
        if (!isCurrentFav) 
          return;

        this.showAlertMessage(`${this.translateService.instant("FailedToSave")}`, 1);
      },
    })
  }
  

  //#endregion
  //#region GRID COLUMNS USER INTERACTIONS HANDLERS
  subscribeToColumnConfigSave(screenUrl: string){
    this.uiProfileService.saveColumnsConfig$.pipe(
      takeUntil(this.destroy$),
      concatMap(data => this.saveColumnsConfigs(data))
    ).subscribe({
      next: response => {
        this.showAlertMessage(this.translateService.instant("SavedSuccessfully"), 2);
        this.cashingUserUIProfileService.Cash(screenUrl, this.uiProfileService.UserUIProfile)
        this.batchRequestData.requests = [];
      },
      error: error => {
        this.showAlertMessage(this.translateService.instant("FailedToSave"), 1);
        this.batchRequestData.requests = [];
      },
    })
  }

  private saveColumnsConfigs(data: any): Observable<any>{
    let screenUrl = this.getUrlSignature(window.location.hash);
    let newColConfigs: IColumnConfig[] = []
    for (let i = 0; i < data.Columns.length; i++) {
      let col = data.Columns[i]
      let colConfig: IColumnConfig = {
        Id: col.DataBaseId,
        ScreenPath: screenUrl,
        Name: col.Name,
        Order: i,
        IsVisible: col.IsVisible,
        GridId: data.GridDomId,
        UserName: UserInfo.UserName
      }
      if(colConfig.Id)
        this.putColConfig(colConfig, i.toString());
      else this.postColConfig(colConfig, i.toString());
      newColConfigs.push(colConfig);
    }
    this.uiProfileService.UserUIProfile.BS_GridColumnConfigs = this.uiProfileService.UserUIProfile.BS_GridColumnConfigs
      .filter(config => config.GridId != newColConfigs[0].GridId)
    this.uiProfileService.UserUIProfile.BS_GridColumnConfigs.push(...newColConfigs);

    if(this.batchRequestData.requests.length > 0){
      return this.httpService.add('$batch', this.batchRequestData)
    }
  }
  postColConfig(colConfig: IColumnConfig, requestId: string){
    var patchRequest = {
      id: requestId,
      method: "POST",
      url: `BS_GridColumnConfig/`,
      headers:{
        "content-type": "application/json;odata.metadata=minimal;odata.streaming=true;",
        "odata-version": "4.0",
      },
      body: colConfig,
    }
    this.batchRequestData.requests.push(patchRequest);
  }
  putColConfig(colConfig: IColumnConfig, requestId: string){
    var postRequest = {
      id: requestId,
      method: "PUT",
      url: `BS_GridColumnConfig/${colConfig.Id}`,
      headers:{
        "content-type": "application/json;odata.metadata=minimal;odata.streaming=true;",
        "odata-version": "4.0",
      },
      body: colConfig,
    }
    this.batchRequestData.requests.push(postRequest);
  }
  //#endregion

  //#region LAYOUT USER INTERACTIONS HANDLERS
  public handleSaveColumnLayoutEvent(screenUrl: string): void{
    this.uiProfileService.saveColumnLayout$
    .pipe(
      takeUntil(this.destroy$),
      concatMap(data => {return this.saveColumnLayout(data);})
    )
    .subscribe({
      next: response => {
        if(response == null){
          this.showAlertMessage(this.translateService.instant("PleaseSelectOptionBeforeSave"), 1);
          return;
        }
        this.uiProfileService.UserUIProfile.BS_CustomScreenLayout = response;
        this.showAlertMessage(this.translateService.instant("SavedSuccessfully"), 2);
        this.cashingUserUIProfileService.Cash(screenUrl,this.uiProfileService.UserUIProfile);
      },
      error: error => {
        this.showAlertMessage(this.translateService.instant("FailedToSave"), 1);
      },
    })
  }

  private saveColumnLayout(data: any): Observable<any>{
    if(data.LayoutColumns != null){
      let deviceMediaQuery = this.getCurrentMediaQuery()
      if(this.uiProfileService.UserUIProfile.BS_CustomScreenLayout.Id ){
        return this.httpService.patch(`BS_CustomScreenLayout/${this.uiProfileService.UserUIProfile.BS_CustomScreenLayout.Id}`,
          {
            "LayoutColumns" : `${data.LayoutColumns}`
          }
        );
      }else{
        let url = this.getUrlSignature(window.location.hash);
        return this.httpService.add(
          `BS_CustomScreenLayout`,
          {
            ScreenPath: url,
            mediaQuery: deviceMediaQuery,
            layoutColumns: data.LayoutColumns, 
            userName: UserInfo.UserName
          }
        )
      }
    }
    return of(null);
  }
  //#endregion

  //#region HELPER FUNCTIONS
  private RequestScreenUserUIProfileFromBackend(screenUrl: string): Observable<any>{
    let mediaQuery = this.getCurrentMediaQuery();
    let username = UserInfo.UserName;
    let getUIProfile = this.httpService.get(`UserScreenUIData/GetUserScreenUIData?userName=${username}&screenPath=${screenUrl}&mediaQuery=${mediaQuery}`)
    .pipe(
      map((response: any)=> {
        const profile: UserUIProfile = new UserUIProfile()
          profile.FavoriteScreens = response.FavoriteScreens;
          profile.BS_CustomScreenLayout= response.BS_CustomScreenLayout;
          profile.BS_GridColumnConfigs= response.BS_GridColumnConfigs;
          return profile;
      }),
      catchError(error => {
        console.error('An error occurred:', error);
        return of(null);
      })
    );
    return getUIProfile;
  }

  getUrlSignature(url: string): string {
    if (url.startsWith('#')){
      url = url.substring(1);
    }
    if (url.startsWith('/')) {
      url = url.substring(1);
    }
    const [path, query] = url.split('?');
    const pathSegments = path.split('/');
    const processedSegments = pathSegments.map(segment => {
      return !isNaN(Number(segment)) ? '*' : segment;
    });
    const processedPath = processedSegments.join('/');
    return query ? `${processedPath}?${query}` : processedPath;
  }

  public showAlertMessage(content: string, type: number) {
    this.loggerService.Content = content;
    this.loggerService.Type = type;
    this.loggerService.Show();
  }

  
  public getCurrentMediaQuery(): string {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      return '1200';
    } else if (window.matchMedia('(min-width: 992px)').matches) {
      return '992';
    } else if (window.matchMedia('(min-width: 768px)').matches) {
      return '768';
    } else {
      return '767';
    }
  }
  //#endregion

  public cleanSubscribtions(){
    this.destroy$.next();
  }
}
